import { ButtonProps, Dropdown, DropdownProps, MenuProps } from "antd";
import { CustomButton } from "ui";
import { ReactComponent as DownloadIcon } from "images/downloadIcon.svg";

type Props = {
  className?: string;
  disabled?: boolean;
  items: MenuProps["items"];
  icon?: React.ReactNode;
  loading?: boolean;
  btnProps?: ButtonProps;
  dropdownProps?: DropdownProps;
};

export const DropdownButton = ({
  className,
  disabled = false,
  btnProps,
  items,
  loading,
  icon = <DownloadIcon />,
  dropdownProps,
}: Props) => {
  return (
    <Dropdown
      menu={{
        items: items,
      }}
      placement="topLeft"
      disabled={disabled || loading}
      {...dropdownProps}
    >
      <CustomButton
        icon={icon}
        size="small"
        type="text"
        className={className}
        loading={loading}
        disabled={disabled || loading}
        {...btnProps}
      />
    </Dropdown>
  );
};
